<script lang="ts">
  import {createEventDispatcher} from 'svelte';
  import {fly} from 'svelte/transition';
  import {page} from '$app/stores';

  import {mostRecentServiceProvider} from '$lib/stores/service-providers';

  import {getParameterizedRoute, isActive} from '$lib/utils/routes';
  import {Route} from '$lib/enums/routes';
  import {Icon, IconId} from '$lib/components/icon';

  import {MenuState} from './enums';

  const dispatch = createEventDispatcher();
  const portfolioRoutes = Object.values(Route)
    .filter((value) => value.startsWith(Route.PortfolioList))
    .concat(Route.OrganizationPortfolioList);

  let menuState = MenuState.Closed;
  let scheduledState: MenuState | undefined;

  $: reactivelyDispatchMenuState(menuState);

  export function toggleMenu(event: Event): void {
    event.preventDefault();

    const referenceState = scheduledState || menuState;

    menuState =
      referenceState === MenuState.Open ? MenuState.Closed : MenuState.Open;

    setScheduledState(undefined);
  }

  export function closeMenu(): void {
    menuState = MenuState.Closed;

    setScheduledState(undefined);
  }

  function reactivelyDispatchMenuState(state: MenuState) {
    dispatchMenuState(state);
  }

  function setScheduledState(state?: MenuState) {
    scheduledState = state;
  }

  function dispatchMenuState(state: MenuState) {
    dispatch('menustatechange', state);
  }
</script>

<div class="menu-container--primary" data-css-state={menuState}>
  <ul class="menu menu--primary">
    <li
      in:fly={{x: -8}}
      class="menu__item"
      class:menu__item--current={isActive($page.url.pathname, [
        Route.Dashboard,
      ])}
    >
      <a href={getParameterizedRoute(Route.Dashboard)} data-sveltekit-prefetch>
        <span class="menu__item__icon">
          <Icon id={IconId.Home} />
        </span>

        <span class="menu__item__text"> Organisations </span>
      </a>
    </li>

    {#if $mostRecentServiceProvider}
      <li
        in:fly={{x: -8}}
        class="menu__item"
        class:menu__item--current={isActive(
          $page.url.pathname,
          portfolioRoutes,
        )}
      >
        <a
          href={getParameterizedRoute(Route.PortfolioList, {
            serviceProviderId: $mostRecentServiceProvider.sys.id,
          })}
          data-sveltekit-prefetch
        >
          <span class="menu__item__icon">
            <Icon id={IconId.Folder} />
          </span>

          <span class="menu__item__text"> Portfolios </span>
        </a>
      </li>
    {/if}
  </ul>
</div>
